<mat-form-field subscriptSizing="dynamic">
  <mat-label [translate]="labelKey"></mat-label>
  <mat-select [value]="currentValue" (valueChange)="onChangeValue($event)" [disabled]="disabled">
    @if (allowNull) {
      <mat-option [value]="0">{{ nullValueLabelKey | translate }}</mat-option>
    }
    @for (option of options; track option.value) {
      <mat-option [value]="option.value">
        @if (option.labelKey) {
          {{ option.labelKey | translate }}
        } @else {
          {{ option.label }}
        }
      </mat-option>
    }
  </mat-select>
</mat-form-field>
